import React, {Component, useEffect, useState} from "react"
import {compose} from "recompose"
import {Input} from "reactstrap";
import {GoogleMap, GroundOverlay, Marker, withGoogleMap, withScriptjs} from "react-google-maps"

// assets
import styleMap from "../../data/style_map.json";
// import pinIcon from "../../assets/images/map/pin/pinDefault.svg";
import pinRed from "../../assets/images/map/pin/pin_red.svg";
import pinBlue from "../../assets/images/map/pin/pin_blue.svg";
// import pinPurple from "../../assets/images/map/pin/pin_purple.svg";
// import pinYellow from "../../assets/images/map/pin/pin_yellow.svg";
import xcOverlay from "../../assets/images/map/overlay/xc.jpg";
import xhOverlay from "../../assets/images/map/overlay/xh.jpg";
import hxmOverlay from "../../assets/images/map/overlay/overlay_hxm.png";

// components
import {GenericTableButton} from "../buttons/buttonsActions";

// labels
import {TT_ADD_AT_END, TT_EMPTY, TT_SEARCH_NEAREST} from "../i18n/toolTips";

// services & providers
import {mapFunctions} from "./mapFunctions";

const google = window.google = window.google ? window.google : {}
let overlayOption = {
    clickable: true
}

const MapComponent = compose(withScriptjs, withGoogleMap)(props => {

    const [radio, setRadio] = useState(10);
    const [ googleConfig, setGoogleConfig ] = useState(null);

    const getUrl = (udnCode) => {
        switch (udnCode.toLowerCase()) {
            case 'xc' :
                return xcOverlay;

            case 'xh' :
                return xhOverlay;

            case 'hx' :
            case 'hxm' :
            case 'hxa' :
                return hxmOverlay;

        }
    }

    const getMapOptions = () => {
        let _mapOptions = props.setBounds(new google.maps.LatLngBounds(
            new google.maps.LatLng(props.googleMapConfig?.bound?.sw?.lat, props.googleMapConfig?.bound?.sw?.lng),
            new google.maps.LatLng(props.googleMapConfig?.bound?.ne?.lat, props.googleMapConfig?.bound?.ne?.lng)));
        _mapOptions = {
            ..._mapOptions,
            center: props.googleMapConfig?.mapOptions?.center,
        }

        return _mapOptions;
    }

    console.log('MapComponent: ',  props.selectedMarker)
    return (
        <>
            <GoogleMap
                options={getMapOptions()}
                onClick={props.onMapClick}>
                {
                    props.markers.map(( marker ) => {
                        return ( <Marker
                                onClick={props.onMarkerClick.bind(this, marker)}
                                key={marker.id}
                                label={ marker.showOrder?.toString() || ''}
                                position={ marker.position }
                                animation={google.maps.Animation.DROP}
                                icon={{
                                    url:  pinRed,
                                    scaledSize: new google.maps.Size(30, 30)
                                }}
                            />
                        )
                    })
                }
                {
                    props.selectedMarker &&
                    <Marker
                        onClick={props.onMarkerClick.bind(this, props.selectedMarker)}
                        key={props.selectedMarker.id}
                        label={ '' }
                        position={ props.selectedMarker.position }
                        animation={google.maps.Animation.DROP}
                        icon={{
                            url:  pinBlue,
                            scaledSize: new google.maps.Size(30, 30)
                        }}
                    />
                }
                {
                    ( props.googleMapConfig?.overlay?.udn.toLowerCase() === "xc"
                        || props.googleMapConfig?.overlay?.udn.toLowerCase() === "xh"
                        || props.googleMapConfig?.overlay?.udn.toLowerCase() === "hx"
                        || props.googleMapConfig?.overlay?.udn.toLowerCase() === "hxm"
                        || props.googleMapConfig?.overlay?.udn.toLowerCase() === "hxa"
                    ) &&
                    <GroundOverlay
                        options={overlayOption}
                        defaultUrl={getUrl(props.googleMapConfig?.overlay?.udn)}
                        url={getUrl(props.googleMapConfig?.overlay?.udn)}

                        onClick={props.onMapClick}

                        defaultBounds={new google.maps.LatLngBounds(
                            new google.maps.LatLng(props.googleMapConfig?.overlay?.pto1?.lat, props.googleMapConfig?.overlay?.pto1?.lng),
                            new google.maps.LatLng(props.googleMapConfig?.overlay?.pto2?.lat, props.googleMapConfig?.overlay?.pto2?.lng)
                        )}
                        bounds={new google.maps.LatLngBounds(
                            new google.maps.LatLng(props.googleMapConfig?.overlay?.pto1?.lat, props.googleMapConfig?.overlay?.pto1?.lng),
                            new google.maps.LatLng(props.googleMapConfig?.overlay?.pto2?.lat, props.googleMapConfig?.overlay?.pto2?.lng)
                        )}
                    />
                }
                {
                    props.mode === 'TRACE' &&
                    <div className="map_custom_buttons">
                        {/*<GenericTableButton toolTip={TT_ADD_AT_START} icon={'fa-light fa-code-branch fa-rotate-90'} permission={'edit'} onClick={props.onAddPrev}/>*/}
                        {/*<GenericTableButton toolTip={TT_SEARCH_NEAREST} icon={'fa-solid fa-tower-broadcast'} permission={'edit'} onClick={props.searchNearest}/>*/}
                        <GenericTableButton toolTip={TT_EMPTY} icon={'fa-solid fa-droplet-slash fa-rotate-180'} permission={'edit'} onClick={props.onClearMarkers}/>
                        <GenericTableButton toolTip={TT_ADD_AT_END} icon={'fa-light fa-code-branch fa-rotate-270'} permission={'edit'} onClick={props.onAddConsec}/>
                        <GenericTableButton toolTip={TT_SEARCH_NEAREST} icon={'fa-solid fa-tower-broadcast'} permission={'edit'} onClick={_ => props.searchNearest(radio) }/>
                        <Input type="number"
                               name="radio"
                               min={0}
                               step={1}
                               value={radio}
                               onChange={e => setRadio(parseInt(e.target.value))}
                        />
                    </div>
                }
                {
                    props.mode === 'ACCESS_POINTS' &&
                    <div className="map_custom_buttons">
                        <Input type="number"
                               name="radio"
                               min={0}
                               step={1}
                               value={radio}
                               onChange={e => setRadio(parseInt(e.target.value))}
                        />
                        <GenericTableButton toolTip={TT_SEARCH_NEAREST} icon={'fa-solid fa-tower-broadcast'} permission={'edit'} onClick={_ => props.searchNearest(radio) }/>
                    </div>
                }
            </GoogleMap>
        </>

    )
})


const MapController = (props) => {

    const [googleMapConfig, setGoogleMapConfig] = useState(props?.googleMapConfig !== undefined ? props?.googleMapConfig : {});
    const [markers, setMarkers] = useState(props.markers ? props.markers : []);
    const [marker, setMarker] = useState(props.marker);
    const [selectedMarker, setSelectedMarker] = useState(props.selectedMarker ? props.selectedMarker : null);
    const [nearestMarkers, setNearestMarkers] = useState([]);
    const [mode, setMode] = useState(props.mode);
    const [updateMarkerPosition, setUpdateMarkerPosition] = useState(props.updateMarkerPosition ? props.updateMarkerPosition : false);
    const [pointA, setPointA] = useState( props.pointA ? props.pointA : { lat: 0, lng: 0 } );

    useEffect(() => {
        setMarkers(props.markers);
    }, [props.markers]);

    useEffect(() => {
        // if (googleMapConfig?.overlay?.udn === "xc"
        //     || googleMapConfig?.overlay?.udn === "xh"
        //     || googleMapConfig?.overlay?.udn?.toLowerCase() === "hxm"
        //     || googleMapConfig?.overlay?.udn?.toLowerCase()  === "hxa"
        // ) {
        setGoogleMapConfig({
            ...googleMapConfig,
            mapOptions : {
                ...googleMapConfig.mapOptions,
                center: props?.googleMapConfig.mapOptions?.center,
                styles : styleMap
            }
        });
        // }
    }, [props?.googleMapConfig.mapOptions]);

    // Ejemplo:
    const onMapClick = (event) => {
        switch (mode) {
            case 'TRACE' :
                onMapClickTrace(event);
                return;

            case 'POINT_SELECT' :
                onMapClickPointSelect(event);
                return;

            case 'ACCESS_POINTS' :
                onMapClickAccess(event);
                return;

        }
    };

    const setBounds = (bounds) => {
        let _mapOptions = {
            ...googleMapConfig.mapOptions
        };

        if (googleMapConfig?.overlay?.udn === "xc" || googleMapConfig?.overlay?.udn === "xh")
            _mapOptions.restriction = {
                strictBounds: false,
                latLngBounds: bounds
            }

        return _mapOptions;
    }

    const onMapClickPointSelect = (event) => {
        if (updateMarkerPosition) {
            let newPosition = {
                lat: event.latLng.lat(),
                lng: event.latLng.lng()
            }
            if (markers.length > 0) {
                let newMarker = markers[0];
                newMarker.position = newPosition;
                // setState({});
                props.onMapClick(newMarker);
            } else {
                let newMarker = {}
                newMarker.position = newPosition;
                setMarkers([newMarker]);
                props.onMapClick(newMarker);
            }
        }
    }

    const onMapClickTrace = (event) => {
        if (updateMarkerPosition) {

            const _markers = markers.slice();
            let _newMarker = {
                title:  "marker" + _markers.length,
                name: "marker" + _markers.length,
                showOrder: _markers.length,
                lat: event.latLng.lat(),
                lng: event.latLng.lng(),
                position: {
                    lat: event.latLng.lat(),
                    lng: event.latLng.lng()
                }
            }

            _markers.push(_newMarker);
            setMarkers(_markers);
            props.onMapClick(_newMarker);
        }
    }

    const onMapClickAccess = (event) => {
        const _markers = markers.slice();
        let _newMarker = {
            title:  "marker" + _markers.length,
            name: "marker" + _markers.length,
            showOrder: _markers.length,
            lat: event.latLng.lat(),
            lng: event.latLng.lng(),
            position: {
                lat: event.latLng.lat(),
                lng: event.latLng.lng()
            }
        }

        _markers.push(_newMarker);
        setMarkers(_markers);
        props.onMapClick(_newMarker);
    }

    const onMarkerClick = (marker) => {
        switch (mode) {
            case 'TRACE' :
                onMarkerClickTrace(marker);
                return;

            case 'POINT_SELECT' :
                onMarkerClickPointSelect(marker);
                return;

            case 'ACCESS_POINTS' :
                onMarkerClickAccess(marker);
                return;

        }
    }

    const onMarkerClickPointSelect = (marker) => {
        setMarker(marker);
        props.onMarkerClick(marker);
    }

    const onMarkerClickTrace = (_marker) => {
        const _nearestMarkers = nearestMarkers.slice();

        if (_nearestMarkers.length) { // Significa que si hay marcadores cercanos
            const index = _nearestMarkers.findIndex(m => m.position.lat === _marker.position.lat && m.position.lng === _marker.position.lng);

            if (index !== -1){
                let _markers = markers.slice();
                const selectedMarkerIndex = _markers.findIndex(m => m.position.lat === marker.position.lat && m.position.lng === marker.position.lng);

                let _newMarker = {
                    showOrder : (selectedMarkerIndex === 0 ? 0 : _markers.length + 1),
                    originalOrder : (selectedMarkerIndex === 0 ? 0 : _markers.length + 1),
                    position: {
                        lat: _nearestMarkers[index].position.lat,
                        lng: _nearestMarkers[index].position.lng
                    }
                }

                if (selectedMarkerIndex === _markers.length - 1) { // Si el marcador seleccionado es el último
                    _markers.push(_newMarker); // Agregar al final
                } else if (selectedMarkerIndex === 0) { // Si el marcador seleccionado es el primero
                    // _markers.unshift(_newMarker); // Agregar al inicio
                    // _markers = [
                    //     _newMarker,
                    //     ..._markers
                    // ]

                    let reorderedMarkers = []
                    reorderedMarkers.push(_newMarker)
                    markers.map(m => {
                        reorderedMarkers.push({
                            showOrder: reorderedMarkers.length,
                            originalOrder: reorderedMarkers.length,
                            position: {
                                lat: m.position.lat,
                                lng: m.position.lng
                            }
                        })
                    })
                    _markers = reorderedMarkers;
                }

                setMarkers(_markers);
                setNearestMarkers([]);
                props.onMapClick(_newMarker);
            }
        } else {
            setMarker(_marker);
            props.onMarkerClick(_marker);
        }
    }

    const onMarkerClickTraceBK = (marker) => {
        const _nearestMarkers = nearestMarkers.slice();

        if (_nearestMarkers.length) { // Significa que si hay marcadores cercanos
            const index = _nearestMarkers.findIndex(m => m.position.lat === marker.position.lat && m.position.lng === marker.position.lng);

            if (index !== -1){
                const _markers = markers.slice();
                // const selectedMarkerIndex = _markers.findIndex(m => m.position.lat === marker.position.lat && m.position.lng === marker.position.lng);
                const selectedMarkerIndex = _markers.length - 1;

                if (selectedMarkerIndex !== -1 && (selectedMarkerIndex > 0)) {
                    let _newMarker = {
                        title:  "marker" + _markers.length,
                        name: "marker" + _markers.length,
                        lat: _nearestMarkers[index].position.lat,
                        lng: _nearestMarkers[index].position.lng,
                        position: {
                            lat: _nearestMarkers[index].position.lat,
                            lng: _nearestMarkers[index].position.lng
                        }
                    }

                    _markers.push(_newMarker);
                    setMarkers(_markers);
                    setNearestMarkers([]);
                    props.onMapClick(_newMarker);
                } else if (selectedMarkerIndex !== -1 && (selectedMarkerIndex === 0)) {
                    // reordenar lista
                    let _newMarker = {
                        title:  "marker1",
                        name: "marker1",
                        lat: _nearestMarkers[index].position.lat,
                        lng: _nearestMarkers[index].position.lng,
                        position: {
                            lat: _nearestMarkers[index].position.lat,
                            lng: _nearestMarkers[index].position.lng
                        }
                    }

                    let reorderedMarkers = []
                    reorderedMarkers.push(_newMarker)
                    markers.map(m => {
                        reorderedMarkers.push({
                            title:  "marker" + reorderedMarkers.length,
                            name: "marker" + reorderedMarkers.length,
                            lat: m.position.lat,
                            lng: m.position.lng,
                            position: {
                                lat: m.position.lat,
                                lng: m.position.lng
                            }
                        })
                    })
                }

            }
        } else {
            setMarker(marker);
            props.onMarkerClick(marker);
        }

    }

    const onMarkerClickAccess = (marker) => {
        let _markers = markers.slice();
        const ix = _markers.findIndex(n => n.id === marker.id)

        if ( ix === -1 ) {
            _markers[ix] = {
                id: marker.id,
                showOrder: marker.length,
                position: marker.position
            }
        }

        if (_markers) {
            setMarkers(_markers);
        }

        props.onMarkerClick( marker );
    }

    const onClearMarkers = () => {
        setMarkers([]);
        props.onClearMarkers( );
    }

    const onAddConsec = () => {
        setMarkers([mapFunctions.getLastToFirst(markers)])
        props.onAddConsec( );
    }

    const onAddPrev = () => {
        setMarkers([0])
        props.onAddPrev( );
    }

    // 1.- seleccionar marcador
    // 2.- cargar marcadores cercanos
    // 3.- se debe seleccionar uno de los marcadores mas cercanos, al ejecutar el onMarkerSelect de alguno de los marcadores cercanos, agregar este a los marcadores.
    const searchNearest = (_radio) => {
        props.searchNearest(_radio )
            .then(_nearestPoints => {
                if (_nearestPoints?.length){
                    const _nearestMarkers = mapFunctions.mapPointsToMarkers(_nearestPoints)

                    setNearestMarkers(_nearestMarkers);
                }
            })
            .catch(ex => {
                console.log(ex);
            });
    }

    // No olvides devolver tu componente al final
    console.log('MapController: ',  props.selectedMarker)
    return (
            <MapComponent
                googleMapConfig={googleMapConfig}
                markers={[ ...markers, ...nearestMarkers ]}
                selectedMarker={marker}
                mode={mode}
                updateMarkerPosition={updateMarkerPosition}
                onMarkerClick={onMarkerClick}
                onMapClick={ onMapClick }
                onClearMarkers={onClearMarkers}
                onAddConsec={onAddConsec}
                onAddPrev={onAddPrev}
                searchNearest={searchNearest}
                setBounds={setBounds}
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCk3DIMp9YWIAPf1QRjv9zVRVyjJZ2t0Gw&v=3.exp&libraries=geometry,drawing,places"
                loadingElement={<div style={{height: `100%`}}/>}
                containerElement={<div className={'map_component_container'}/>}
                // containerElement={<div style={{height: `800px`}}/>}
                mapElement={<div style={{height: `100%`}}/>}
            />
    );
};

export default MapController;
